/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */

import { format } from 'date-fns'

export function mod(n, m) {
	return (n % m + m) % m
}

export function decodeUrl(url) {
	return url.replace(/%2F/g, '/').replace(/%40/g, '@')
}

export function getSafeNestedObject(rootObj, nestedProps) {
	nestedProps = nestedProps.split('.')
	let newObj = null
	if (rootObj === null) {
		console.log('root null')
		return null
	} else if (rootObj === undefined) {
		console.log('root undefined')
		return undefined
	} else if (typeof rootObj === 'object') {
		newObj = rootObj
		for (var i = 0; i < nestedProps.length; i++) {
			if (newObj === null) {
				console.log('newobj null')
				return null
			} else if (typeof newObj !== 'object') {
				console.log('newobj not object')
				return null
			} else if (Array.isArray(newObj)) {
				console.log('newobj is array')
				return null
			} else if (newObj.hasOwnProperty(nestedProps[i])) {
				newObj = newObj[nestedProps[i]]
			} else {
				console.log(newObj)
				console.log(nestedProps[i])
				console.log('newobj doesnt have prop')
				return null
			}
		}
	} else {
		console.log('root not object')
		return null
	}
	return newObj
}

function find(list, f) {
	return list.filter(f)[0]
}

export function isEmpty(obj) {
	for (var prop in obj) {
		if (obj.hasOwnProperty(prop)) {
			return false
		}
	}

	return JSON.stringify(obj) === JSON.stringify({})
}

/**
 * Replace carriage return and new lines with an html line break
 * This should be used in v-html in conjunction with any text
 * That could be input with newline characters
 */
export function replaceNewlines(value) {
	if (!value) return ''
	value = value.toString()
	value = value.replace(/(?:\r\n|\r|\n)/g, '<br />')
	return value
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy(obj, cache = []) {
	// just return if obj is immutable value
	if (obj === null || typeof obj !== 'object') {
		return obj
	}

	// if obj is hit, it is in circular structure
	const hit = find(cache, c => c.original === obj)
	if (hit) {
		return hit.copy
	}

	const copy = Array.isArray(obj) ? [] : {}
	// put the copy into cache at first
	// because we want to refer it in recursive deepCopy
	cache.push({
		original: obj,
		copy
	})

	Object.keys(obj).forEach(key => {
		copy[key] = deepCopy(obj[key], cache)
	})

	return copy
}

/**
 * forEach for object
 */
export function forEachValue(obj, fn) {
	Object.keys(obj).forEach(key => fn(obj[key], key))
}

export function isObject(obj) {
	return obj !== null && typeof obj === 'object'
}

export function isPromise(val) {
	return val && typeof val.then === 'function'
}

export function assert(condition, msg) {
	if (!condition) throw new Error(`[vuex] ${msg}`)
}

export function makeid(len) {
	var text = ''
	var possible =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

	for (var i = 0; i < len; i++) {
		text += possible.charAt(Math.floor(Math.random() * possible.length))
	}

	return text
}

export function parseTimeString(timeString) {
	console.log('parseTimeString', timeString)
	if (!timeString)
		return null

		var d = new Date();
		var time = timeString.match( /(\d+)(?::(\d\d))?\s*(p?)/ );
		d.setHours( parseInt( time[1]) + (time[3] ? 12 : 0) );
		d.setMinutes( parseInt( time[2]) || 0 );
		d.setSeconds(0);
		console.log('parseTimeString return: ', d)
		return d;
}

export function compare(a, b) {
	if (a === null || b === null) {
		if (a === null && b === null) {
			return true
		}
		return false
	}
	for (var p in a) {
		//Check property exists on both objects
		if (a.hasOwnProperty(p) !== b.hasOwnProperty(p)) return false;

		switch (typeof (a[p])) {
			//Deep compare objects
			case 'object':
				if (!compare(a[p], b[p])) return false;
				break;
			//Compare function code
			case 'function':
				if (typeof (b[p]) == 'undefined' || (p != 'compare' && a[p].toString() != b[p].toString())) return false;
				break;
			//Compare values
			default:
				if (a[p] != b[p]) return false;
		}
	}

	//Check object 2 for any extra properties
	for (var q in b) {
		if (typeof (a[q]) == 'undefined') return false;
	}
	return true;
}
